import React from "react";

const cassetteBack = `/wp-content/plugins/rockinrudys/images/cassette-back.png`;

export default class Cassette extends React.PureComponent {
	render() {
		const imgStyles = {
			backgroundImage: !this.props.active
				? `url(${this.props.image})`
				: null,
		};
		const trackStyles = {
			backgroundImage: `url(${cassetteBack})`,
		};
		const containerClasses = [
			"gecko-tape-recorder__cassette",
			this.props.active ? "active" : null,
		];

		return (
			<div
				className={containerClasses.join(" ")}
				onClick={this.props.onClick}
			>
				<div className="gecko-tape-recorder__cassette-inner">
					<div className="gecko-tape-recorder__cassette-front">
						<div className="gecko-tape-recorder__cassette-background">
							<div
								className="gecko-tape-recorder__cassette-tracks"
								style={trackStyles}
							/>
							<div
								className="gecko-tape-recorder__cassette-img"
								style={imgStyles}
							/>
						</div>
						<div className="gecko-tape-recorder__cassette-label">
							<div className="gecko-tape-recorder__cassette-text">
								{this.props.label}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
